import { render } from "./TotalCrowd.vue?vue&type=template&id=5afa633c&scoped=true"
import script from "./TotalCrowd.vue?vue&type=script&lang=js"
export * from "./TotalCrowd.vue?vue&type=script&lang=js"

import "@/assets/css/print.css?vue&type=style&index=0&id=5afa633c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afa633c"]])

export default __exports__